import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ConfigureScreensModalComponent } from '../configure-screens-modal/configure-screens-modal.component';
import { SelectScreensModalComponent } from '../select-screens-modal/select-screens-modal.component';
import { SelectStatesModalComponent } from '../select-states-modal/select-states-modal.component';
import { PolicyXML, State, Operation, Feature, Screen } from 'src/app/models/common'
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { LoaderService } from 'src/app/services/loader.service';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VersionHistoryComponent } from '../version-history/version-history.component';

@Component({
  selector: 'app-configure-policy-modal',
  templateUrl: './configure-policy-modal.component.html',
  styleUrls: ['./configure-policy-modal.component.scss']
})
export class ConfigurePolicyModalComponent implements OnInit,IDeactivateComponent {
  IsDirty=false;
  policyid: string;
  policy: PolicyXML;
  module: string;
  states: State[];
  screens: Screen[] = [];
  selectedStates: any[];
  selectedScreens: any[];
  rejectOp: boolean;
  onholdOp: boolean;
  discardedOp: boolean;
  withdrawOp: boolean;
  allOperations: Operation[];
  action: Subject<any> = new Subject();
  screencode: any;
  @Input() public Content: any;
  NAME:string="";
  RECORD_STATE:boolean=true;
  configurePolicyForm = new UntypedFormGroup({
    NAME: new UntypedFormControl(true),
    RECORD_STATE:new UntypedFormControl(true),
    manageStateDraft: new UntypedFormControl(true),
    manageStateSubmitted: new UntypedFormControl(true),
    manageStateClosed: new UntypedFormControl(true),
    rejectOperation: new UntypedFormControl(true),
    onholdOperation: new UntypedFormControl(true),
    discardedOperation: new UntypedFormControl(true),
    withdrawOperation: new UntypedFormControl(true)
  });
 
  constructor(
    private modalService: NgbModal,
    private summaryService: AdministrationSummaryService,
    public activemodalRef: NgbActiveModal,
    public route: ActivatedRoute,
    public commonService:CommonService,
    public loaderService:LoaderService
  ) {
  }

  ngOnInit() {
    this.screencode = this.Content.screencode;
    this.rejectOp = false;
    this.onholdOp = false;
    this.withdrawOp = false;
    // Call Get States
    this.getStates();
  }


  populateJson() {
    this.policy = new PolicyXML();
    this.policy.Module = this.module;
    this.policy.States = [];
    var state = new State();
    this.policy.States.push(state);
  }

  getStates() {
    this.summaryService.getSummaryData('api/policy/getstates?id=' + this.screencode+"&mode="+this.Content.heading+"&policyID="+this.Content.Policy_ID).subscribe((result) => {
      this.selectedStates = [];
      let TempselectStatesList=[];
      this.policy = result;
      this.NAME=this.policy.NAME;
      this.RECORD_STATE=this.policy.RECORD_STATEExt;
      this.policyid = result.ID;
      this.getScreens();
      let len = this.policy.States.length;
      for (var i = 0; i < len; i++) {
        if (this.policy.States[i].ISCHECKED)
        {
          let stName=this.policy.States[i].NAME;
          if(stName=="Onhold")
          {
            stName= "On-hold";
          }
          if(stName=="Discard" || stName=="discard")
          {
            stName= "Discarded";
          }
         // TempselectStatesList.push(stName);
          TempselectStatesList.push({Name:stName,RecordStatus:this.policy.States[i].RecordStatus, STATUSCODE: this.policy.States[i].STATUSCODE});
        }
      }
      this.selectedStates = [...TempselectStatesList];
      this.CheckOperationsBasedOnXml();
    });
  }

  getScreens() {
    this.selectedScreens = [];
    let len = this.policy.States[0].Features.length;
    for (var i = 0; i < len; i++) {
      if (this.policy.States[0].Features[i].ISCHECKED)
        this.selectedScreens.push({Name:this.policy.States[0].Features[i].Name,RecordStatus:this.policy.States[0].Features[i].RecordStatus});
    }
   
  }

  pickStates() {
    let StateArray=[];
    this.policy.States.forEach((state)=>{
      StateArray.push({NAME:state.NAME,SNO:state.SNO,ISCHECKED:state.ISCHECKED,Order:state.Order,IsReviwAvailable:state.IsReviwAvailable,STATUSCODE:state.STATUSCODE,RecordStatus:state.RecordStatus})
    });
    const modalRef = this.modalService.open(SelectStatesModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: '',
      states: StateArray
    
    }
    modalRef.result.then(result => {
      this.selectedStates=[];
      this.IsDirty=true;
      this.policy.States.forEach((state)=>{
        if(state.STATUSCODE!="9")
        {
          let CurrentselectedStae= result.filter((item)=>{
            return item.STATUSCODE==state.STATUSCODE;
          })[0];
          if(CurrentselectedStae!=null && CurrentselectedStae!=undefined && CurrentselectedStae.ISCHECKED==true)
          {
            state.ISCHECKED=true;
            state.IsReviwAvailable=CurrentselectedStae.IsReviwAvailable;
            let stName=state.NAME;
            if(stName=="Onhold")
            {
              stName= "On-hold";
            }
            if(stName.toLowerCase()=="discard")
            {
              stName= "Discarded";
            }
          }
          else{
            state.ISCHECKED=false;
          }
          state.SNO=CurrentselectedStae.SNO;
          if(state.STATUSCODE=="99")
          {
              state.SNO=this.policy.States.length+1;
          }
       }
      
      });
      this.policy.States =this.policy.States.sort((a, b) => a.SNO - b.SNO);
      this.policy.States.forEach((state)=>{ 
        if(state.ISCHECKED && state.STATUSCODE!="9")
        this.selectedStates.push({Name:state.NAME,RecordStatus:state.RecordStatus});
      });
      //this.policy.States =this.policy.States.sort((a, b) => a.SNO - b.SNO);
   });
    
  }

  pickScreens() {
    let modalRef = this.modalService.open(SelectScreensModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: '',
      screens: JSON.parse(JSON.stringify(this.policy.States[0].Features)),
      content: null,
      module:this.screencode
    }
    modalRef.result.then(result => {
      
      this.IsDirty=true;
      let index=0;
      this.selectedScreens=[];
      result.forEach((item,index)=>{
         item.Sno=index
      });
      let CurrentselectedScreens = result.filter((item)=>{return item.ISCHECKED==true});
      CurrentselectedScreens.forEach((item)=>{
        this.selectedScreens.push({Name:item.Name,RecordStatus:item.RecordStatus});
      });
      this.policy.States.forEach((state)=>{
        state.Features.forEach((screen)=>{
          index=index+1;
           if(CurrentselectedScreens.length>0)
           {
              let IsSelect=CurrentselectedScreens.filter((sscreen)=>{
                return sscreen.Code==screen.Code
              })[0];
              let screenData=result.filter((sscreen)=>{
                return sscreen.Code==screen.Code
              })[0];
              if(IsSelect!=undefined && IsSelect!=null)
              {
                screen.ISCHECKED = true;
              }
              else{
                  screen.ISCHECKED = false;
              }
              if(screenData!=undefined && screenData!=null)
              {
                screen.Sno=screenData.Sno; 
              }
           }
           else{
            screen.Sno=index;
            screen.ISCHECKED = false;
           }
        });
        state.Features =state.Features.sort((a, b) => a.Sno - b.Sno);
      });
    });
  }

  SavePolicyConfig() {
    if (this.selectedStates == null || this.selectedStates.length == 0 || this.selectedStates.length == undefined) {
      this.commonService.ValidationBanner("Please select Required States");
      return;
    }
    if (this.selectedScreens == null || this.selectedScreens.length == 0 || this.selectedScreens.length == undefined) {
      this.commonService.ValidationBanner("Please select Required Screens");
      return;
    }
    if (this.NAME == null || this.NAME == "" || this.NAME == undefined || this.NAME.trim()=="") {
      this.commonService.ValidationBanner("Please enter Name");
      return;
    }
    else{
      this.policy.NAME=this.NAME;
    }
    this.policy.RECORD_STATEExt=this.RECORD_STATE;
    let IsInactiveScreens=false;
    let IsInactiveStates=false;
    let ScreenList=[];
    this.policy.States.forEach((state) => {
      if(state.STATUSCODE!="9")
      {
        if(state.RecordStatus == "Inactive" && state.ISCHECKED==true)
        {
          IsInactiveStates=true ;
        }
          state.Features.forEach((currentFeature) => {
            if (currentFeature != undefined && currentFeature != null) {
              let IsNotConfigure=false;
              if(currentFeature.ExternalUser=="" || currentFeature.ExternalUser==null || currentFeature.ExternalUser==undefined)
              {
                 IsNotConfigure=true;
              }
              if(currentFeature.InternalUser=="" || currentFeature.InternalUser==null || currentFeature.InternalUser==undefined)
              {
                IsNotConfigure=true;
              }
              if(IsNotConfigure && currentFeature.ISCHECKED==true && state.ISCHECKED==true)
              {
                IsNotConfigure=false;
                if(ScreenList.indexOf(currentFeature.Name)==-1)
                {
                  ScreenList.push(currentFeature.Name);
                }
               
              }
              if(currentFeature.RecordStatus=="Inactive" && currentFeature.ISCHECKED==true)
              {
                IsInactiveScreens=true;
              }
            }
            
          });
      }
      
     });
     if(ScreenList.length>0)
     {
        let message="Please update workflows for below screens </br>"
        ScreenList.forEach((item)=>{
          message=message+"'" + item + "'" + "</br>"
        })
       this.commonService.ValidationBanner(message);
       return;
     }
     
    if(IsInactiveStates){
      this.commonService.ValidationBanner("Please remove inactive state(s) to save the details");
      return;
    }
    if (IsInactiveScreens) {
      this.commonService.ValidationBanner("Please remove deleted/inactive screen(s) to save the details");
      return;
    }
    let URL="";
    if(this.policy.ID=="")
    {
      URL="api/policy/Insertpolicy";
    }
    else{
      URL="api/policy/updatepolicy";
    }
   // Save button Click
    this.summaryService.savePolicy(this.policy,URL).subscribe((result) => {
      if (result.Status === 0) {
        this.IsDirty=false;
        if(this.policy.ID=="")
          {
            this.commonService.SuccessBanner('Workflow Setup added successfully');
            this.activemodalRef.close();
          }
          else{
            this.commonService.SuccessBanner('Workflow setup updated successfully');
            this.activemodalRef.close();
          }
       
      }
      else {
        if(result.ErrorCode=="REFERENCE")
        {
          this.commonService.ValidationBanner("Workflow '"+this.policy.NAME+"' already exists, please enter unique name");
        }
        this.commonService.ValidationBanner(result.Message);
      }
    });

  }

  configureScreens() {
    this.IsDirty=true;
    let modalRef = this.modalService.open(ConfigureScreensModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vvlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: '',
      content: null,
      policy: this.policy
    }
    modalRef.result.then(res => {
      this.policy = res;
    });

  }
  close()
  {
     this.activemodalRef.dismiss();
  }
  

  versionHistory() {
    let modalRef = this.modalService.open(VersionHistoryComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      screencode:this.screencode
    }
    modalRef.result.then(res => {
      this.getStates();
    });
  }

  ChangeOperation() {
    this.IsDirty=true;
    if (this.rejectOp) {
      this.policy.States.map((person) => {
        if(person.NAME=="Rejected" || person.NAME=="Reject")
        {
          person.ISCHECKED=true;
        }
      });

    }
    else {
      this.rejectOp = false;
      this.policy.States.map((person) => {
        if(person.NAME=="Rejected" || person.NAME=="Reject")
        {
          person.ISCHECKED=false;
        }
      });
    }

    if (this.onholdOp) {
      this.policy.States.map((person) => {
        if(person.NAME=="On-Hold" || person.NAME=="Onhold")
        {
          person.ISCHECKED=true;
        }
      });
    }
    else {
      this.onholdOp = false;
      this.policy.States.map((person) => {
        if(person.NAME=="On-Hold" || person.NAME=="Onhold")
        {
          person.ISCHECKED=false;
        }
      });
    }

    if (this.discardedOp) {
      this.policy.States.map((person) => {
        if(person.NAME=="Discard" || person.NAME=="Discard")
        {
          person.ISCHECKED=true;
        }
      });
    }
    else {
      this.discardedOp = false;
      this.policy.States.map((person) => {
        if(person.NAME=="Discard" || person.NAME=="Discard")
        {
          person.ISCHECKED=false;
        }
      });
    }


    if (this.withdrawOp) {
      this.policy.States.map((person) => {
        if(person.NAME=="Withdrawn" || person.NAME=="Withdraw")
        {
          person.ISCHECKED=true;
        }
      });
    }
    else {
      this.withdrawOp = false;
      this.policy.States.map((person) => {
        if(person.NAME=="Withdrawn" || person.NAME=="Withdraw")
        {
          person.ISCHECKED=false;
        }
      });
    }

  }

  CheckOperationsBasedOnXml() {
    this.rejectOp=false;
    this.onholdOp=false;
    this.withdrawOp=false;
      this.policy.States.map((person) => {
        if((person.NAME=="Rejected" || person.NAME=="Reject") && person.ISCHECKED)
        {
           this.rejectOp=true;
        }
        if((person.NAME=="On-Hold" || person.NAME=="Onhold") && person.ISCHECKED)
        {
          this.onholdOp=true;
        }
        if((person.NAME=="Withdrawn" || person.NAME=="Withdraw") && person.ISCHECKED)
        {
          this.withdrawOp=true;
        }
      });

  }
  canExit() {
    if (this.IsDirty) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}
